// Подвод камеры к отряду, выбранному автовыбором на этапах войны (см.
// GameScene.focusCameraOnAutoSelectedUnit, utils/camera/autoSelectionFraming,
// change unit-auto-selection). Отряд в центральной зоне свободной области
// кадр не двигает; за ней кадр сдвигается ровно настолько, чтобы ячейки
// действий отряда попали в зону. Других автоматических переездов кадра в фазе
// войны нет: осмотр ячейки и выбор отряда кликом камеру не двигают

// Длительность переезда: видно, что кадр поехал, но клик не «залипает».
// Характер — как у зума колесом (Sine), только в обе стороны: мягкий разгон
// и торможение, без рывка на старте
export const AUTO_SELECTION_CAMERA_PAN_DURATION_MS = 400;
export const AUTO_SELECTION_CAMERA_PAN_EASE = 'Sine.easeInOut';

// Центральная зона свободной области — доля ее ширины и высоты вокруг центра:
// область делится на четыре части по каждой оси, зона — две средние
export const AUTO_SELECTION_CAMERA_CENTRAL_ZONE_FRACTION = 0.5;

// Запасной подъем цели над центром кадра — доля ВЫСОТЫ КАДРА, пока отступ
// футера еще не измерен (витрина, тесты, первые кадры): низ экрана занимает
// футер, и без подъема отряд легко оказался бы под ним. Кадр тогда считается
// так, будто снизу уже стоит футер высотой в две такие доли (худший случай),
// и центр свободной области поднят на одну. С измеренным футером подъем не
// нужен.
//
// Высота футера с открытой панелью (замеры на 375x812, канва 742px): от
// 182px до 263px, на десктопе та же доля экрана. Половина худшего случая —
// 0.18 высоты кадра
export const AUTO_SELECTION_CAMERA_UP_SHIFT_FRACTION = 0.18;

// Камера уже стоит где надо — не дергаем ее ради долей пикселя. Порог в
// пикселях канвы (не CSS: канва отрисована с учетом devicePixelRatio)
export const AUTO_SELECTION_CAMERA_MIN_SHIFT_PX = 4;
